import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import ModalGeneralSuccessfully from 'screens/ModalGeneralSuccessfully';
import ModalGeneralFailed from 'screens/ModalGeneralFailed';
import { useMutation } from '@apollo/client';
import { RETRY_TRANSACTION } from 'graphql/service';
import colors from 'constants/colors';
import { Container } from './styles';

const ModalRetry = ({
  buttonStyle,
  transactionId,
  cardNumber,
  setBill,
}) => {

    const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
    const [failedIsOpen, setFailedIsOpen] = useState(false)
    const [isOpen, setIsOpen] = useState(false)

    const [retryTransaction, {loading}] = useMutation(RETRY_TRANSACTION, {
      onCompleted: (data) => {
        setBill(prevBill => ({
          ...prevBill,
          transactions: [...prevBill.transactions, data.retryTransaction]
        }))
        setSuccessfullyIsOpen(true)
        setFailedIsOpen(false)
        setIsOpen(false)
      },
      onError: (error) => {
        setFailedIsOpen(true)
        setIsOpen(false)
      }
    })

  const handleRetry = () => {
    if(loading) return
    retryTransaction({
      variables: {
        input: {
          transactionId,
          reason: ""
        },
      },
    });
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        buttonLabel='Retry'
        buttonStyle={buttonStyle}
        className="modal-success"
        success
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              height: 100%;
              padding: 24px;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <div className='text'>{`The system will attempt to process the payment again using the customer's saved card ending in ${cardNumber?.slice(-4)}. Do you want to proceed?`}</div>
          <div className='buttonContainer'>
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
                margin-right: 16px;
              `} 
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleRetry}
              data-loading={loading}
              additionalstyle={`
                width: 60px;
              `}
            >
              {loading? null: 'Retry'}
            </Button>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        cardNumber={cardNumber}
        type='retry'
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleRetry}
        type='retry'
      />
    </>
  );
}

export default ModalRetry;
